import { render } from "./StudentGuadrianAssociationModal.vue?vue&type=template&id=1f0253d4"
import script from "./StudentGuadrianAssociationModal.vue?vue&type=script&lang=js"
export * from "./StudentGuadrianAssociationModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__